module.exports = __webpack_public_path__ + "img/stick_activites_vtt.f0e49c6e.svg";